import { render } from "./LockedUserModal.vue?vue&type=template&id=ac64b5ea&scoped=true&ts=true"
import script from "./LockedUserModal.vue?vue&type=script&lang=ts"
export * from "./LockedUserModal.vue?vue&type=script&lang=ts"

import "./LockedUserModal.vue?vue&type=style&index=0&id=ac64b5ea&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac64b5ea"]])

export default __exports__